import { getFieldName } from 'root/utils/forms/getFieldData';

/*
* This function is used to customize the field tracking data we send to GA. If a user interacts with a form
* and completes a field, in most cases we send the data with this format: field_name|completed
* However, when a user completes one of the fields listed in the exclusion array,
* we send data in this format: field_name|field_value
- If the current field value is empty, it returns the string "empty"
- If the current field is NOT in the fieldExclusionArray, it returns the string "completed"
- If the current field IS in the fieldExclusionArray, it returns the current field's value
* */
const getTrackingValue = (
    element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
) => {
    if (element instanceof HTMLSelectElement) {
        return element?.options[element?.selectedIndex]?.dataset.tracking;
    } else {
        return element.dataset.wizardTracking ?? null;
    }
};
const getAnonymizedFieldValue = (
    element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement,
    formIsWizard = false
) => {
    let fieldName: string | undefined, fieldValue: string | undefined;
    const trackingValue = getTrackingValue(element);
    // Excluded fields can send their real value to Google Analytics, otherwise we just send 'completed'
    const fieldExclusionArray = [
        'product',
        'role',
        'business_type',
        'secondary_business_type',
        'agnostic_business_type',
        'existing_business',
        'ecommerce_choice',
        'estimated_annual_gtv',
        'gtv',
        'country',
    ];

    if (element) {
        if (formIsWizard) {
            /*
             * The wizard form field data gets stored in a data attribute with a "\" to separate the name and value
             * */
            [fieldName, fieldValue] =
                element.dataset.wizardFormStoreField?.split('|') ?? [];
        } else {
            /*
             * For non-wizard forms, we get the input name and value from a form input field
             * */
            fieldName = getFieldName(element);
            fieldValue = trackingValue ?? element.value;
        }

        if (fieldName && fieldValue) {
            return fieldExclusionArray.includes(fieldName) ? fieldValue : 'completed';
        }
    }

    return 'empty';
};

export { getAnonymizedFieldValue };
